<template>
  <div class="util-add">
    <router-link :to="action">
      <button>
        <img src="@/assets/img/util-pencil.svg" alt="" />
        <span>Tambahkan Catatan</span>
      </button>
    </router-link>
  </div>
</template>
<script lang="js">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Prop } from "vue-property-decorator";
@Component({
  components: {
  },
})
export default class UtilitiesTabTitle extends Vue {
  @Prop() action;

}
</script>
